/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ILxsHeroHeaderButtonViewProps } from './lxs-hero-header-button';

export default (props: ILxsHeroHeaderButtonViewProps) => {
    const { classNames, href, linkText, ariaLabel, target, iconClassName } = props;

    return (
        <a
            href={href}
            className={classNames}
            target={target}
            rel={target === '_blank' ? 'noopener noreferrer' : undefined}
            aria-label={ariaLabel}
        >
            {iconClassName && <span className={iconClassName} aria-hidden='true' />}
            {linkText}
        </a>
    );
};
